// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-col {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.container {
  overflow-x: auto;
  white-space: nowrap;
  margin-top: 10px;
}

th, td {
  padding: 0.1em 1em;
}

.tablaMeteo {
  border-top: 1px solid lightgray;
  border-bottom: 1px solid lightgray;
  margin-bottom: 10px;
}

.labelHora {
  font-family: "Roboto Condensed", sans-serif;
  font-weight: 300;
}

.labelTemperatura {
  font-family: "Roboto Condensed", sans-serif;
  font-weight: bold;
}

.labelProbLLuvia {
  font-family: "Roboto Condensed", sans-serif;
  font-weight: bold;
}

.labelHumedadRelativa {
  font-family: "Roboto Condensed", sans-serif;
  font-weight: 200;
}

.imgEstadoCielo {
  width: 6em;
  height: 6em;
}

.tituloUbicacion {
  font-family: Roboto Condensed;
  font-size: medium;
}`, "",{"version":3,"sources":["webpack://./src/app/components/meteorologia/meteorologia.component.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AACD;;AAEA;EAEC,gBAAA;EACA,mBAAA;EACA,gBAAA;AAAD;;AAGA;EACC,kBAAA;AAAD;;AAGA;EACC,+BAAA;EACA,kCAAA;EACA,mBAAA;AAAD;;AAGA;EACC,2CAAA;EACA,gBAAA;AAAD;;AAGA;EACC,2CAAA;EACA,iBAAA;AAAD;;AAIA;EACC,2CAAA;EACA,iBAAA;AADD;;AAIA;EACC,2CAAA;EACA,gBAAA;AADD;;AAIA;EACC,UAAA;EACA,WAAA;AADD;;AAIA;EACC,6BAAA;EACA,iBAAA;AADD","sourcesContent":["ion-col {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n}\r\n\r\n.container {\r\n\t//width: 30em;\r\n\toverflow-x: auto;\r\n\twhite-space: nowrap;\r\n\tmargin-top: 10px;\r\n}\r\n\r\nth, td {\r\n\tpadding: .1em 1em;\r\n}\r\n\r\n.tablaMeteo {\r\n\tborder-top: 1px solid  lightgray;\r\n\tborder-bottom: 1px solid  lightgray;\r\n\tmargin-bottom: 10px;\r\n}\r\n\r\n.labelHora{\r\n\tfont-family: 'Roboto Condensed', sans-serif;\r\n\tfont-weight: 300;\r\n}\r\n\r\n.labelTemperatura{\r\n\tfont-family: 'Roboto Condensed', sans-serif;\r\n\tfont-weight: bold;\r\n\r\n}\r\n\r\n.labelProbLLuvia{\r\n\tfont-family: 'Roboto Condensed', sans-serif;\r\n\tfont-weight: bold;\r\n}\r\n\r\n.labelHumedadRelativa{\r\n\tfont-family: 'Roboto Condensed', sans-serif;\r\n\tfont-weight: 200;\r\n}\r\n\r\n.imgEstadoCielo{\r\n\twidth: 6em;\r\n\theight: 6em;\r\n}\r\n\r\n.tituloUbicacion{\r\n\tfont-family: Roboto Condensed;\r\n\tfont-size: medium;\r\n\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
